export type QuestionType = 'radio' | 'text' | 'multiple-choice';
export interface QuestionTO {
  id: number;
  questionnairesId: number;
  type: QuestionType;
  question: string;
  questionOrder: number;
  isMandatory: boolean;
  value: string[] | number[] | null;
  createdAt: string;
  updatedAt: string;
}

export const toQuestionTO = (question: any): QuestionTO => {
  return {
    id: question.id,
    questionnairesId: question.questionnaires_id,
    type: question.type,
    question: question.question,
    questionOrder: question.question_order,
    isMandatory: question.is_mandatory,
    value: question.value,
    createdAt: question.created_at,
    updatedAt: question.updated_at,
  };
};
